/**
 * useIsMobile (Feb 2026 / P4 Mobile-Scan)
 *
 * Detection-Hook für Mobile-Devices.
 * Kombiniert UA-Sniffing (zuverlässig für iOS-Safari) und Media-Query
 * (für Tablets/Desktop in Mobile-Mode).
 */
import { useEffect, useState } from 'react';

const MOBILE_UA = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i;
const MOBILE_BREAKPOINT = 768;

export default function useIsMobile() {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return false;
    return MOBILE_UA.test(window.navigator.userAgent)
      || window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`).matches;
  });

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`);
    const ua = MOBILE_UA.test(window.navigator.userAgent);
    const onChange = () => setIsMobile(ua || mq.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  return isMobile;
}
